'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactIs_production_min = {};

exports.__exports = reactIs_production_min;
